module.exports = __webpack_public_path__ + "img/cards1_front18.70992fe6.png";